import { Component, Input, OnInit } from '@angular/core';

import { orderBy } from 'rev-shared/util/SortUtil';

import { BaseImportDialogComponent } from './BaseImportDialog.Component';
import { IBoxVideo } from './Import.Types';

@Component({
	selector: 'import-box-dialog',
	templateUrl: './ImportBoxDialog.Component.html',
	standalone: false
})
export class ImportBoxDialogComponent extends BaseImportDialogComponent implements OnInit {
	@Input() public teamId: string;

	public errorGeneric: boolean = false;
	public boxRecordings: IBoxVideo[];

	public import(): void {
		this.isLoading = true;

		this.getSelectedImports().forEach((selectedImport: IBoxVideo) =>
			this.ImportExternalMediaService.importBoxVideo(
				selectedImport.id,
				selectedImport.name,
				selectedImport.description,
				this.teamId
			)
		);

		this.closeDialog();
	}

	public fetchRecordings(): Promise<IBoxVideo[]> {
		return this.ImportExternalMediaService.getBoxVideos(this.teamId);
	}

	public processRecordings(recordings: IBoxVideo[]): void {
		this.boxRecordings = recordings ? orderBy(recordings, item => item.createdDate, false) : [];
	}

	public handleError(error: any): void {
		this.errorGeneric = true;
	}

	public clearErrors(): void {
		this.errorGeneric = false;
	}

	public assignDataGridSettings(): void {
		super.assignGridDefaultColDef();
		super.assignGridOptions();
		this.assignGridColumnDefs();
	}

	public assignGridColumnDefs(): void {
		this.gridColumnDefs = [
			...this.getCommonColumnDefs('name', 'createdDate', 'size', ['durationInMs'])
		];
	}
}
